import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import SignUp from "./pages/SignUp";
import OrderIndex from "./pages/OrderIndex";
import Home from "./pages/Home";
import ProductDeet from "./pages/ProductDeet";
import CartPage from "./pages/CartPage";
import CartContext from "./context/CartContext";
import Product from "./context/Product";
import EditProfile from "./pages/EditProfile";
import Saved from "./pages/Saved";
import OrdersPage from "./components/Order/OrdersPage";
import { ToastContainer } from "react-toastify";
import { Toaster } from "react-hot-toast";
import HowToUse from "./pages/HowToUse";
import Categories from "./pages/Categories";
import Success from "./pages/Success";
import AdminLayout from "./pages/Admin/AdminLayout";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminOrders from "./pages/Admin/AdminOrders";
import AdminProducts from "./pages/Admin/AdminProducts";
import AdminCoupons from "./pages/Admin/AdminCoupons";
import FooterSection from "./components/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";

const PublicLayout = () => {
  return (
    <>
      <div className="min-h-screen flex flex-col">
        <div className="flex-grow">
          <Outlet />
        </div>
        <FooterSection />
      </div>
    </>
  );
};

function App() {
	return (
		<Product>
			<CartContext>
				<Toaster
					toastOptions={{
						style: {
							fontSize: "14px",
						},
						success: {
							style: {
								background: "#E1F7EB",
								color: "#20AA5F",
								borderColor: "#20AA5F",
								borderWidth: 0.5,
							},
						},
						error: {
							style: {
								background: "#F7EAE9",
								color: "#FF3B30",
								borderColor: "#FF3B30",
								borderWidth: 0.5,
							},
						},
					}}
				/>
				<ToastContainer position="bottom-center" autoClose={3000} />
				<BrowserRouter>
					<Routes>
						<Route path="auth" element={<SignUp />} />
						<Route element={<PublicLayout />}>
							<Route path="/" element={<Home />} />
							<Route path="order" element={<OrdersPage />} />
							<Route path="order/:orderId" element={<OrderIndex />} />
							<Route path="details/:productId" element={<ProductDeet />} />
							<Route path="categories/:category" element={<Categories />} />
							<Route path="cart" element={<CartPage />} />
							<Route path="edit-profile" element={<EditProfile />} />
							<Route path="saved" element={<Saved />} />
							<Route path="how-to-use" element={<HowToUse />} />
							<Route path="success" element={<Success />} />
							<Route path="privacy-policy" element={<PrivacyPolicy />} />
							<Route path="terms" element={<TermsConditions />} />
							<Route
								path="*"
								element={
									<div className="w-full h-screen flex items-center justify-center">
										Page Not found
									</div>
								}
							/>
						</Route>
						
						{/* Admin Protected Routes */}
						<Route path="/admin" element={<AdminLayout />}>
							<Route index element={<AdminDashboard />} />
							<Route path="orders" element={<AdminOrders />} />
							<Route path="products" element={<AdminProducts />} />
							<Route path="coupons" element={<AdminCoupons />} />
						</Route>
					</Routes>
				</BrowserRouter>
			</CartContext>
		</Product>
	);
}

export default App;
